import { AVAILABLE_LOCALES, DEFAULT_LOCALE } from "@/lib/config"
import type { GenericTranslationsObject, Translations, Locale } from "./types"

import systemDE from "../i18n/system/de.json"
import systemEN from "../i18n/system/en.json"
import systemFR from "../i18n/system/fr.json"
import systemIT from "../i18n/system/it.json"

import de from "@/i18n/de.json"
import en from "@/i18n/en.json"
import fr from "@/i18n/fr.json"
import it from "@/i18n/it.json"

export const loadTranslations = (): Translations => {
  return {
    de: mergeAndFlattenTranslations(systemDE, de),
    en: mergeAndFlattenTranslations(systemEN, en),
    fr: mergeAndFlattenTranslations(systemFR, fr),
    it: mergeAndFlattenTranslations(systemIT, it)
  }
}
export const translate = (
  currentLocale: Locale,
  key: string,
  localizedObject: Translations
) => {
  let locale = currentLocale as Locale
  if (!AVAILABLE_LOCALES.includes(currentLocale)) {
    locale = DEFAULT_LOCALE
  }
  return (
    localizedObject[locale]?.[key] ??
    `[missing translation for locale=${locale} and key=${key}]`
  )
}

export const translateFromObject = (
  currentLocale: Locale,
  localizedObject: Record<string, string> | undefined
): string => {
  if (!localizedObject) {
    return `[missing translation: no localized object provided]`
  }

  const translation = localizedObject[currentLocale]
  if (translation) {
    return translation
  } else {
    return `[missing translation for locale=${currentLocale}]`
  }
}

export const flattenTranslations = (
  translations: GenericTranslationsObject,
  prefix: string = ""
): { [key: string]: string } => {
  return Object.keys(translations).reduce<{ [key: string]: string }>(
    (acc, key): { [key: string]: string } => {
      const flatKey = prefix ? `${prefix}.${key}` : key
      const value = translations[key]

      if (value && typeof value === "object" && !Array.isArray(value)) {
        Object.assign(acc, flattenTranslations(value, flatKey))
      } else if (typeof value === "string") {
        acc[flatKey] = value
      }
      return acc
    },
    {}
  )
}

export const mergeAndFlattenTranslations = (
  system: GenericTranslationsObject,
  app: GenericTranslationsObject
): { [key: string]: string } => {
  const flatSystemTranslations = flattenTranslations(system)
  const flatAppTranslations = flattenTranslations(app)
  return { ...flatSystemTranslations, ...flatAppTranslations }
}

export const TRANSLATIONS: Translations = loadTranslations()
